import { IAdmissionGeneratedDocumentResponse } from "@/src/types/admissionOfficeGeneratedDocument";

const readString = (value: unknown): string => (typeof value === "string" ? value : "");

const readNumber = (value: unknown): number | undefined =>
  typeof value === "number" && Number.isFinite(value) ? value : undefined;

/**
 * Normalizes create-document API responses (PDFpath / pdf_path, nested `data`, etc.).
 */
export const parseGeneratedDocumentResponse = (raw: unknown): IAdmissionGeneratedDocumentResponse | null => {
  if (!raw || typeof raw !== "object") return null;

  const root = raw as Record<string, unknown>;
  const nested = root.data && typeof root.data === "object" ? (root.data as Record<string, unknown>) : null;
  const source = nested ?? root;

  const pdfPath = readString(source.PDFpath) || readString(source.pdf_path);
  if (!pdfPath) return null;

  return {
    PDFpath: pdfPath,
    fullName: readString(source.fullName) || readString(source.full_name),
    title: readString(source.title),
    id: readNumber(source.id) ?? readNumber(root.id),
    document_id: readNumber(source.document_id) ?? readNumber(root.document_id),
    data: nested ? { id: readNumber(nested.id) } : undefined,
  };
};
